module.exports = [{"type":"title","text":"2025-12-16"},{"type":"normal","text":"賬號 API 頻率限制更新。","style":{"font-weight":"bold"},"children":[{"type":"html","text":"移除賬號接口分組 [2] 與分組 [3] 的 IP 頻率限制。"},{"type":"html","text":"原先分組內所有接口基於 IP 的總限頻（2000 次 / 10 秒）已不再生效。"},{"type":"html","text":"分組內單個接口基於 IP 的限頻（300 次 / 10 秒）亦同步移除。"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2025-12-16.json
// module id = fgRV
// module chunks = 3